// Slot Capacity Approval — shared across EditCapacityModal, UploadPayEarnModal, and
// ApprovalQueue, which all need to turn a routedToTier string into named people to show the
// requester. Reuses whatever getCapacityApprovers() already returned (approvers + roleChain) —
// no separate lookup endpoint exists, and none is needed.

import React from 'react';

export const TIER_LABELS = {
    FM: 'FM',
    SFM: 'SFM',
    SUPER_ADMIN: 'Super Admin',
    DSP_VENDOR: 'DSP Vendor',
    DSP_ADMIN: 'DSP Admin',
    APPROVER: 'Approver',
};

// approvers: SlotCapacityApproverResponse[] (org's Approver-tier rows)
// roleChain: SlotCapacityRoleChainResponse[] (FM/SFM/Super Admin/DSP tiers resolved from StaffPay roles)
export const resolveApproverNames = (tier, { approvers = [], roleChain = [] } = {}) => {
    if (!tier) return [];
    if (tier === 'APPROVER') {
        return approvers.filter((a) => a?.isActive).map((a) => a.name);
    }
    return roleChain.filter((r) => r?.tier === tier).map((r) => r.name);
};

// One combined sentence for "who this request is routed to", not a paragraph per role: only the
// role/tier labels are bold (DSP Admin / Approver / Approver-Decider), never the names or the
// connecting words. additionalApproverTier/additionalApproverNames/approverDeciderApplicable come
// straight off the backend response (SlotCapacityChangeResponse / SlotCapacityUploadWithheldResponse /
// SlotCapacityApprovalRequestResponse) — the DSP_ADMIN->APPROVER escalation union already lives
// server-side in SlotCapacityApprovalHelper, never re-derived here. Absent/empty fields render
// nothing, so a non-escalated request reads exactly as it always has.
export const RoutedToLine = ({
    routedToTier,
    approverNames,
    additionalApproverTier,
    additionalApproverNames,
    approverDeciderApplicable,
}) => (
    <>
        Routed to <b>{TIER_LABELS[routedToTier] ?? routedToTier}</b>
        {approverNames?.length ? ` — ${approverNames.join(', ')}` : ''}
        {additionalApproverNames?.length ? (
            <>
                {' and '}
                <b>{TIER_LABELS[additionalApproverTier] ?? additionalApproverTier}</b>
                {' — '}
                {additionalApproverNames.join(', ')}
            </>
        ) : null}
        {approverDeciderApplicable ? (
            <>
                {' and '}
                <b>Approver-Decider</b> allowlist
            </>
        ) : null}
        .
    </>
);
